import { useCallback } from 'react';
import { useFormContext, UseFormReturn } from 'react-hook-form';
import { LabelValueSource } from 'graphql/types';
import { useLabelsFormFieldContext } from 'modules/timesheet-labels';

import {
  PCPTVariantType,
  DependantLabelData,
  DependantLabels
} from '../components/schema';

const setLabelValue = (
  label: DependantLabelData,
  setValue: UseFormReturn['setValue'],
  formField: string
) => {
  setValue(
    `${formField}.${label.index}.label`,
    {
      ...label.label,
      valueSource: LabelValueSource.User
    },
    { shouldValidate: true, shouldDirty: true }
  );
};
const getProgramClientValue = (
  client: DependantLabelData | undefined,
  program: DependantLabelData | undefined
) => {
  if (client) {
    return client;
  } else if (program) {
    return program;
  } else return;
};

export const useAcceptCptSuggestion = (
  dependentLabels: DependantLabels,
  labelType: PCPTVariantType
): (() => void) => {
  const { setValue } = useFormContext();
  const {
    timesheetLabels: timesheetLabelsFormField
  } = useLabelsFormFieldContext();
  const { client, project, task, program } = dependentLabels;
  const programClientValue = getProgramClientValue(client, program);
  return useCallback(() => {
    switch (labelType) {
      case 'task':
        setLabelValue(task, setValue, timesheetLabelsFormField);
        setLabelValue(project, setValue, timesheetLabelsFormField);
        programClientValue &&
          setLabelValue(programClientValue, setValue, timesheetLabelsFormField);
        break;
      case 'project':
        setLabelValue(project, setValue, timesheetLabelsFormField);
        programClientValue &&
          setLabelValue(programClientValue, setValue, timesheetLabelsFormField);
        break;
      case 'client':
        client && setLabelValue(client, setValue, timesheetLabelsFormField);
        break;
      case 'program':
        program && setLabelValue(program, setValue, timesheetLabelsFormField);
    }
  }, [
    client,
    labelType,
    program,
    programClientValue,
    project,
    setValue,
    task,
    timesheetLabelsFormField
  ]);
};
